import React from 'react';
import './WhyUs.css';

import { images, whyChooseUs } from '../../../constants';
import { Heading } from '../../../components';

const WhyUs = () => {
    // Split points into two columns (4 points each column)
    const midPoint = Math.ceil(whyChooseUs.points.length / 2);
    const leftColumnPoints = whyChooseUs.points.slice(0, midPoint);
    const rightColumnPoints = whyChooseUs.points.slice(midPoint);

    return (
        <section className="why-us" id="why-us">
            <div className="box-container">
                
                {/* Left Side: Image + Content */}
                <div className="image">
    
                    {/* Section heading */}
      <Heading title={whyChooseUs.heading} subTitle={whyChooseUs.sub} sideHeading linear />
                    <p>{whyChooseUs.content}</p>
                    <img src={images.blog1} alt="Why Choose Us" />
                </div>

                {/* Right Side: Key Features */}
                <div className="why-features">
                    
                    {/* First Column of Points */}
                    <div className="points">
                        {leftColumnPoints.map(point => (
                            <div className="point" key={point.id}>
                                <div className="icon">{point.icon}</div>
                                <h3>{point.title}</h3>
                                <p>{point.description || 'Professional service with attention to detail'}</p>
                            </div>
                        ))}
                    </div>

                    {/* Second Column of Points */}
                    <div className="points">
                        {rightColumnPoints.map(point => (
                            <div className="point" key={point.id}>
                                <div className="icon">{point.icon}</div>
                                <h3>{point.title}</h3>
                                <p>{point.description || 'Professional service with attention to detail'}</p>
                            </div>
                        ))}
                    </div>

                </div>

            </div>
        </section>
    );
};

export default WhyUs;